import { render, staticRenderFns } from "./CallerIdListCreateOrEditFromPhoneNumber.vue?vue&type=template&id=20d35d1c&"
import script from "./CallerIdListCreateOrEditFromPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./CallerIdListCreateOrEditFromPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports